<template>
  <div v-if="active">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'WizardPage',
  
  data() {
    return {
      active: false
    }
  },

  props: {
    requires: [Array, Object]
  },
  
  methods: {
    touchForErrors() {
      if(this.requires === undefined) return;

      if(Array.isArray(this.requires)) {
        for (const v of this.requires) {
          v.$touch();
        }
      } else {
        this.requires.$touch();
      }
    },

    isComplete() {
      if(this.requires === undefined) return true;

      if(Array.isArray(this.requires)) {
        for (const v of this.requires) {
          if(v.$invalid) return false;
        }
      } else {
        if(this.requires.$invalid) return false;
      }
      return true;
    }
  }
}
</script>

<style>

</style>